"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hrZones = void 0;
var hrZones = exports.hrZones = [{
  id: 'ZAGREB',
  name: 'Zagreb',
  country: 'HR',
  cornerNW: {
    latitude: 45.8501,
    longitude: 15.8725
  },
  cornerSE: {
    latitude: 45.7326,
    longitude: 16.1207
  },
  subZones: [{
    name: 'Zagreb Centre-ville',
    zipcodes: {
      10000: {
        label: '10000'
      }
    }
  }, {
    name: 'Zagreb Gornji Grad',
    zipcodes: {
      10010: {
        label: '10010'
      }
    }
  }, {
    name: 'Zagreb Trnje',
    zipcodes: {
      10020: {
        label: '10020'
      }
    }
  }, {
    name: 'Zagreb Dubrava',
    zipcodes: {
      10040: {
        label: '10040'
      }
    }
  }, {
    name: 'Zagreb Maksimir',
    zipcodes: {
      10090: {
        label: '10090'
      }
    }
  }]
}];